<template>
  <v-row class="slider-seo ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <div v-swiper:mySwiper="swiperOptions" >
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(slide, i) in slidesURL" :key="`slide-`+i">
<!--             {{slide}} -->
            <v-row class="ma-0 pa-0" align="center" justify="center">
              <v-col  class="ma-0 pa-0">
                <img :src="slide" alt="" class="img-item-swiper">
<!--                     <v-img :src="slide" contain>

                    </v-img>                
                <v-row class="slide-seo" align="center" justify="space-around">
                  <v-col class="hjg56"> -->

                   <!--  <img :src="slide" alt="" > -->
                    <!--                        <div  :class="[isMobile ? 'display-1' : 'display-2']">{{slide.text}}</div> 
                    <div  :class="[isMobile ? 'title' : 'display-1']">{{slide.subtext}}</div>-->
<!--                   </v-col>
                </v-row> -->
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <!--     <div class="swiper-button-next d-flex justify-end">
            <v-btn 
            class="ma-2 btn-round-border-w" 
            fab
            outlined
            x-large                            
            color="#fff"
             v-if="$vuetify.breakpoint.smAndUp"
            >
              <v-icon light>mdi-chevron-right</v-icon>
            </v-btn>
        </div>-->
        <!--     <div class="swiper-button-prev d-flex justify-start">
            <v-btn 
            class="ma-2 btn-round-border-w" 
            fab
            outlined
            x-large                            
            color="#fff"
             v-if="$vuetify.breakpoint.smAndUp"
            >
              <v-icon light>mdi-chevron-left</v-icon>
            </v-btn>



        </div>-->
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "SwiperSEO",
  props: ["listImage"],
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      classes: [],
      slides: [
        {
          text: "ВЕСНА 2020",
          subtext: "Новые коллекции уже в магазинах ТРЦ Гагаринский",
          style: {
            color: "#fff",
            backgroundImage: "url('https://picsum.photos/1600/400?random12')",
            backgroundSize: "cover",
          },
        },

        {
          text: "LaserLand",
          subtext: "Центр внеземных развлечений",
          style: {
            color: "#fff",
            backgroundImage: "url('https://picsum.photos/1600/400?random22')",
            backgroundSize: "cover",
          },
        },

        {
          text: "Рестораны и Кафе",
          subtext: "Разнообразие на любой вкус",
          style: {
            color: "#fff",
            backgroundImage: "url('https://picsum.photos/1600/400?random37')",
            backgroundSize: "cover",
          },
        },
      ],
      swiperOptions: {
        centeredSlides: true,
        centerInsufficientSlides: true,
        normalizeSlideIndex: false,
         effect: 'fade',
        spaceBetween: 0,
        centeredSlides: true,
        autoHeight: true,
      //  height: 450,
        loop: true,
/*         autoplay: {
            delay: 6000,
            disableOnInteraction: false
          },  */
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          //  nextEl: '.arrowr-slider',
          prevEl: ".swiper-button-prev",
          //  prevEl: '.arrowl-slider'
        },
      },
    };
  },
  computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
    slidesList() {
      return this.listImage.map((slide) => {
        return {
          text: "",
          subtext: "",
          style: {
            color: "#fff",
            backgroundImage: "url('" + slide.path + "')",
            backgroundSize: "cover",
          },
        };
      });
    },
    slidesURL() {
      return this.listImage.map((slide) => {
        return slide.path});
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    isMobile: {
      get() {
        return this.$store.state.app.isMobile;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setIsMobile", val);
      },
    },
  },
  methods: {
    hoverOver: function (e) {
      if(DEBUG) console.log("over = ", e);
      this.classes = ["bounce-enter-active"];
    },
    hoverOut: function () {
      if(DEBUG) console.log("out");
      this.classes = [];
    },
    hoverOutTimeout: function () {
      setTimeout(() => {
        if(DEBUG) console.log("out");
        this.classes = [];
      }, 1000);
    },
    resetSwiperTimeout: function () {
      const vApp = this;
      setTimeout(() => {
        if(DEBUG) console.log("update swiper SEO :>>");
        vApp.mySwiper.update();
      }, 1500);
    },
  },
  mounted() {
    // current swiper instance
    let vApp = this;
    vApp.$nextTick(function () {
      if(DEBUG) console.log("Current Swiper SEO instance object", this.mySwiper);
      vApp.resetSwiperTimeout();
    });
    //  this.swiper.slideTo(1, 1000, false)
  },
  beforeDestroy: function () {
    let vApp = this;
    if(DEBUG) console.log("Удаляем SWIPER SEO");
    vApp.mySwiper.destroy();
  },
};
</script>

<style >
.swiper-pos {
  position: absolute;
}
/*.swiper-slider {
   height: 300px; 
}*/
.slide-seo {
  background-position: center;
  width: 100%;
  /* height: 300px; */
}
.swiper-container,.img-item-swiper {
  width: 100%;
}
.slider-seo {
  width: 100%;
}

/* .dwnlayer-slider{
  position: absolute;
  bottom: 15px;
  left: 0;
  z-index: 202;
} */
.uplayer-slider {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 201;
}

.arrowl-slider {
  width: 70px;
  height: 300px;
  margin-left: 200px;
  margin-top: -132px;
  background-image: url("../assets/arr-l-w.svg");
  cursor: pointer;
}

.arrowr-slider {
  width: 70px;
  height: 300px;
  margin-right: 200px;
  margin-top: -132px;
  background-image: url("../assets/arr-r-w.svg");
  cursor: pointer;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  content: none;
}
.swiper-button-prev {
  left: 5%;
}
.swiper-button-next {
  right: 5%;
}
.my-bullet {
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
  margin: 0 4px;
}
.my-bullet-active {
  opacity: 1;
  background: #fff;
}
</style>